/**
 * API Configuration
 *
 * Central configuration for API settings and environment variables.
 */

export const apiConfig = {
  /**
   * Base URL for the API
   */
  baseUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000/api/portal',

  /**
   * Whether to use mock API (for development without backend)
   */
  useMockApi: import.meta.env.VITE_USE_MOCK_API !== 'false',

  /**
   * Request timeout in milliseconds
   */
  timeout: 30000,

  /**
   * Google OAuth Client ID
   */
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',

  /**
   * Stripe Public Key
   */
  stripePublicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY || '',

  /**
   * reCAPTCHA Site Key
   */
  recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY || '',

  /**
   * Google Maps API Key
   */
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',

  /**
   * Apple Sign-In Client ID (Service ID)
   */
  appleClientId: import.meta.env.VITE_APPLE_CLIENT_ID || '',

  /**
   * Apple Sign-In Redirect URI
   */
  appleRedirectUri: import.meta.env.VITE_APPLE_REDIRECT_URI || '',
}

/**
 * Check if we're in development mode
 */
export const isDevelopment = import.meta.env.DEV

/**
 * Check if we're in production mode
 */
export const isProduction = import.meta.env.PROD
